import { http } from "../http";

export const endImpersonation = async () => {
  try {
    const response = await http.post(`/api/impersonate/end`);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};
